// Import Sass
import './style.scss';

import 'swiper/css/bundle'; // Swiper CSS

// Content Slider
document.addEventListener('DOMContentLoaded', () => {
    const allSlider = document.querySelectorAll('.wp-block-csb-content-slider-block');
    Object.values(allSlider).map(slider => {
        const sliderEl = document.getElementById(slider.id);
        const calcPercentage = (child, parent) => 100 * parseFloat(child / parent);
        const elWidth = el => parseInt(el?.clientWidth);
        const elHeight = el => parseInt(el?.clientHeight);

        const { slides, columns, columnGap, isLoop, isTouchMove, isAutoplay, speed, effect, isPageClickable, isPageDynamic } = JSON.parse(sliderEl.dataset.slider);

        new Swiper(`#${slider.id} .csbContentSlider`, {
            // Optional parameters
            direction: 'horizontal',
            slidesPerView: columns?.mobile,
            breakpoints: {
                // when window width is >= 576px
                576: { slidesPerView: columns?.tablet },
                // when window width is >= 768px
                768: { slidesPerView: columns?.desktop },
            },
            spaceBetween: columnGap,
            loop: isLoop,
            allowTouchMove: isTouchMove,
            grabCursor: isTouchMove,
            autoplay: isAutoplay ? { delay: speed * 1000 } : false,
            speed: speed * 1000,
            effect,
            fadeEffect: { crossFade: true },
            creativeEffect: {
                prev: {
                    shadow: true,
                    translate: ["-120%", 0, -500],
                },
                next: {
                    shadow: true,
                    translate: ["120%", 0, -500],
                }
            },
            allowSlideNext: true,
            allowSlidePrev: true,
            autoHeight: false,
            notificationClass: null,

            // Controllers
            pagination: {
                el: '.swiper-pagination',
                clickable: isPageClickable,
                dynamicBullets: isPageDynamic
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            }
        });

        const csbContentSliderStyle = document.querySelector(`#${slider.id} .csbContentSliderStyle`); // Style Tag
        let childElPositionCSS = ''; // Style holder
        slides.map((item, index) => {
            const { position, childPositions = [{ left: 5.8, top: 11 }, { left: 5.8, top: 22 }, { left: 5.8, top: 33 }] } = item;
            let positionPlaceholder = position;

            // Select Slider Content and Child
            const sliderContent = document.querySelector(`#${slider.id} .csbContentSlider .slide-${index}:not(.swiper-slide-duplicate) .sliderContent`);
            const contentChild = sliderContent?.children || [];

            // 3.0.0 v fixing start
            // Get some tool for array position
            const childPositionsForOld = (i, top, left) => {
                childPositions[i]['top'] = parseFloat(top);
                childPositions[i]['left'] = parseFloat(left);
            }
            const revI = [...Array(contentChild?.length).keys()].reverse();
            const middleI = Math.ceil(contentChild?.length / 2 - 1);
            const beforeMiddleRevI = [...Array(middleI).keys()].reverse();

            for (let i = 0; i < contentChild.length; i++) {
                // Position recycling
                const contentChildWidthPer = calcPercentage(elWidth(contentChild[i]), elWidth(sliderContent));
                const contentChildHeightPer = calcPercentage(elHeight(contentChild[i]), elHeight(sliderContent));

                if (0 < contentChildWidthPer && 0 < contentChildHeightPer && isFinite(contentChildWidthPer) && isFinite(contentChildHeightPer)) {
                    const verticalLeft = 5.8;
                    const verticalCenter = parseFloat((50 - (contentChildWidthPer / 2)).toFixed(3));
                    const verticalRight = parseFloat((100 - contentChildWidthPer - verticalLeft).toFixed(3));

                    const horizontalTop = (i + 1) * 11;
                    const horizontalCenterQuery = i === middleI ? 50 : i < middleI ? 50 - (11 * (beforeMiddleRevI[i] + 1)) : 50 + (11 * (i - middleI));
                    const horizontalCenter = parseFloat((horizontalCenterQuery - (contentChildHeightPer / 2)).toFixed(3));
                    const horizontalBottom = parseFloat((100 - (11 * (i + 1)) - contentChildHeightPer).toFixed(3));

                    if ('top left' === positionPlaceholder) {
                        childPositionsForOld(i, horizontalTop, verticalLeft);
                    } else if ('top center' === positionPlaceholder) {
                        childPositionsForOld(i, horizontalTop, verticalCenter);
                    } else if ('top right' === positionPlaceholder) {
                        childPositionsForOld(i, horizontalTop, verticalRight);
                    } else if ('center left' === positionPlaceholder) {
                        childPositionsForOld(i, horizontalCenter, verticalLeft);
                    } else if ('center center' === positionPlaceholder) {
                        childPositionsForOld(i, horizontalCenter, verticalCenter);
                    } else if ('center right' === positionPlaceholder) {
                        childPositionsForOld(i, horizontalCenter, verticalRight);
                    } else if ('bottom left' === positionPlaceholder) {
                        childPositionsForOld(revI[i], horizontalBottom, verticalLeft);
                    } else if ('bottom center' === positionPlaceholder) {
                        childPositionsForOld(revI[i], horizontalBottom, verticalCenter);
                    } else if ('bottom right' === positionPlaceholder) {
                        childPositionsForOld(revI[i], horizontalBottom, verticalRight);
                    }
                }
            }
            // 3.0.0 v fix end

            // For CSS styling
            for (let i = 0; i < contentChild.length; i++) {
                childPositions[i] = childPositions[i] || { left: 5.8, top: (i + 1) * 11 };

                childElPositionCSS += `#${slider.id} .csbContentSlider .slide-${index} .sliderContent > *:nth-child(${i + 1}){ top: ${childPositions[i].top}%; left: ${childPositions[i].left}%; } `;
            }
            csbContentSliderStyle.innerText = childElPositionCSS;
        });

        sliderEl?.removeAttribute('data-slider');
    });
});